export const SECTION_TARIFFS = 'tariffs';
export const SECTION_ORDER = 'order';
